import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Service.css";
import AOS from "aos";
import "aos/dist/aos.css";
const Service = ({ service }) => {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 1500,
    });
  }, []);
  const { id, name, price, img } = service;

  return (
    <div
      data-aos="zoom-out-down"
      className="grid grid-cols-2 service-container border-2 hover:shadow-lg  p-4   rounded-lg"
    >
      <div className="flex justify-center items-center ">
        <img className="object-cover h-40 w-48 rounded-lg" src={img} alt="" />
      </div>
      <div className="">
        <h2 className="text-lg text-left lg:text-center lg:text-2xl font-bold text-gray-600 p-2">
          {name}
        </h2>
        <p className="text-green-500 ml-1 text-sm font-bold lg:py-2">
          Price: ৳{price}
        </p>
        <Link to={`/service/${id}`}>
          <button
            className="shadow rounded lg:rounded-lg text-white font-semibold lg:font-bold px-3 py-1.5"
            style={{ background: "#33b8ad" }}
          >
            View Details
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Service;
